module.exports = __webpack_public_path__ + "img/NZ.abd8c85e.png";